import Cookies from 'js-cookie/src/js.cookie';

import {back_to_top} from '../components/back-to-top';
import {ie11} from '../components/ie11';
import {menu} from '../components/menu';
import {slider} from '../components/slider';
import {datalayer} from '../components/datalayer';
import {gallery} from '../components/gallery';
import {seminar_filter} from '../components/seminar-filter';
import {listfilter} from '../components/listfilter';
import {tooltipmap} from '../components/tooltipmap';
import {tileanim} from '../components/tileanim';
import {video} from '../components/video';
import {searchHighlight} from '../components/search-highlight';
import {map} from '../components/map';
import {accordion} from '../components/accordion';
import {skichampionshipForm} from '../components/skichampionship-form';
import {slideoutContact} from '../components/slideout-contact';
import {sectionScrolling} from '../components/section-scrolling';
import {inputBirthday} from '../components/input-birthday';

export default {
  init() {

     if (typeof Cookies.get('mea-cb-thirdparty') == 'undefined' || String(Cookies.get('mea-cb-thirdparty')) != 'true') {
      $('#cookie-agreement-required').removeClass('d-none');
    }

    // Consent Functional Cookies
    $('script[data-cookie-consent]').each(function () {
      let consent = $(this).data('cookie-consent').split('|');
      let code = $(this).html();

      $.each(consent, function (index, val) {
        if (typeof Cookies.get('mea-cb-' + val) != 'undefined' && String(Cookies.get('mea-cb-' + val)) == 'true') {
          eval(code);
          return false;
        }
      });
    });

    $('a[href="#cookies-verwalten"]').click(function (e) {
      e.preventDefault();
      window.meaCookiebanner.showPreferencesDialog();
    });

    menu();
    slider();
    back_to_top();
    datalayer();
    gallery();
    listfilter();
    tooltipmap();
    tileanim();
    video();
    accordion();
    seminar_filter();
    map();
    searchHighlight();
    skichampionshipForm();
    slideoutContact();
    sectionScrolling();
    inputBirthday();
  },

  finalize() {
    ie11();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js